import { render } from "./ReceiptConsolidationReport.vue?vue&type=template&id=7952f6ae&scoped=true"
import script from "./ReceiptConsolidationReport.vue?vue&type=script&lang=js"
export * from "./ReceiptConsolidationReport.vue?vue&type=script&lang=js"

import "./ReceiptConsolidationReport.vue?vue&type=style&index=0&id=7952f6ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7952f6ae"]])

export default __exports__